import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import { getCatalogByCatalogKey } from 'service/catalogsV2';

import { QUERY_STALE_TIME_DEFAULT } from 'constants/globals';

import type LabelValue from 'commons/modules/label-value';

import { sortLocale } from 'utils/array';
import { createOption } from 'utils/form';

/**
 * Hook to fetch and process nationalities catalog
 * Returns sorted and mapped nationalities as LabelValue array
 */
const useNationalities = (): LabelValue[] => {
  const { data: nationalitiesV2Data } = useQuery({
    queryKey: ['nationalitiesV2'],
    queryFn: () => getCatalogByCatalogKey('CAT_NACIONALIDAD'),
    staleTime: QUERY_STALE_TIME_DEFAULT,
  });

  return useMemo(() => {
    if (
      !nationalitiesV2Data ||
      !nationalitiesV2Data.success ||
      !nationalitiesV2Data.data
    ) {
      return [];
    }

    const sortedValues = sortLocale(
      nationalitiesV2Data.data.data,
      'Mexico',
      false,
    );

    return sortedValues.map((catalogData) =>
      createOption({
        label: catalogData.value01 || '',
        value: catalogData.code02 || catalogData.code01 || '',
      }),
    );
  }, [nationalitiesV2Data]);
};

export default useNationalities;
